/* eslint-disable react/no-unescaped-entities */
import Link from 'next/link'
import react from 'react'

interface GoogleSheetsConnectedAppProps {
  id?: string
  monthlyPerformanceReportSpreadsheetId?: string
  monthlyPerformanceReportUrl?: string
  isConnected?: boolean
  sessionId?: string
  oauthCallbackBaseUrl?: string
}

const GoogleSheetsConnectedApp = (props: GoogleSheetsConnectedAppProps) => {
  const [url, setUrl] = react.useState(props.monthlyPerformanceReportUrl)
  const [isConnected, setIsConnected] = react.useState(props.isConnected)
  const [error, setError] = react.useState('')

  async function handleDeleteConnection() {
    const resp = await fetch(`/api/google-sheets/data`, {
      method: 'delete',
      headers: {
				Session: props.sessionId!,
      }
    })

    if (resp.ok) {
      setIsConnected(false)
      setUrl('')
      setError('')
    } else {
      console.error('error deleting connection', await resp.text())
      setError('Error deleting connection')
    }
  }

  async function handleSyncNow() {
    const resp = await fetch('https://7f8blkc298.execute-api.us-east-1.amazonaws.com/prod/sync', {
      method: 'put',
      body: JSON.stringify({
        connector: 'googleSheets',
        session: props.sessionId,
      }),
    })

    if (!resp.ok) {
      const json = await resp.json()
      setError(json.error)
    }
  }

  react.useEffect(() => {
    console.log('updating state', props)
    setUrl(props.monthlyPerformanceReportUrl)
    setIsConnected(props.isConnected)
  }, [
    props.monthlyPerformanceReportSpreadsheetId, 
    props.monthlyPerformanceReportUrl, 
    props.isConnected
  ])

  return (
    <div
    className='border-b border-gray-300 mb-5 bg-slate-200 p-8'
    >
      <button 
        className={`${isConnected ? 'block' : 'hidden'} float-right px-2 text-slate-500 bg-slate-100 border-2 border-slate-300 hover:bg-slate-300 hover:text-blue-500`}
        onClick={() => handleSyncNow()}
      >Sync Now 🔄</button>
      <h2 className="text-2xl text-slate-500">
        <span className="text-blue-700 font-extrabold">GoogleSheets</span>
      </h2>
      <div>
        1. Connect Google Sheets { isConnected && <span className='text-green-500'>✅</span>}

        { !isConnected &&
          <div className='text-med'>
            <a className='inline-block border border-blue-500 bg-blue-500 text-white font-bold py-2 px-4 rounded mt-4'
              href={`https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/drive.file&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${props.oauthCallbackBaseUrl}/oauth-callback/google-sheets&client_id=944473882632-07rnemp1k3s32vtab7oldt7eplp9nbin.apps.googleusercontent.com&prompt=consent`}>
            Authorize</a>
          </div>
        }
        { isConnected &&
          <div className='text-med'>
            <a 
              href={`https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/drive.file&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${props.oauthCallbackBaseUrl}/oauth-callback/google-sheets&client_id=944473882632-07rnemp1k3s32vtab7oldt7eplp9nbin.apps.googleusercontent.com&prompt=consent`}
            >
              Reauthenticate</a>

            <button 
              className=" text-red-800 hover:underline mt-4 px-4 rounded"
              onClick={() => handleDeleteConnection()}>Delete Connection
            </button>  
          </div>
        }
        <div className='block text-red-600'>{ error }</div>
      </div>

      <div className='mt-10'>
        2. Open Spreadsheet 
        <p className='text-sm mt-0'>
          After the initial sync, you can open the spreadsheet to view and edit the data.
        </p>
        { url ? <Link target='_blank' href={url}>Open Google Sheets</Link> : '(Not yet connected)' }
      </div>
   </div>
  )
}

export default GoogleSheetsConnectedApp